'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BaseMenuSection = require('./BaseMenuSection');

var _BaseMenuSection2 = _interopRequireDefault(_BaseMenuSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseMenuSection2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenuSection/index.js
// module id = 259
// module chunks = 11